import { SvgIcon, Typography, useTheme } from '@mui/material';
import { Stack, Box } from '@mui/system';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconHousekeeping } from '../../../../assets/svg/housekeeping.svg';

interface Props {
    className?: string;
}

export const NoUpcomingHousekeeping: FC<Props> = ({ className }) => {
    const { palette, shadows } = useTheme();
    const { t } = useTranslation();

    return (
        <Stack
            alignItems="stretch"
            width="100%"
            className={className}
            css={{
                position: 'relative',
                color: 'inherit',
                textDecoration: 'none',
                background: palette.background.default,
                zIndex: 'auto',

                '::after': {
                    content: '""',
                    position: 'absolute',
                    zIndex: -1,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    top: 0,
                    boxShadow: shadows[1],
                },
            }}
            padding={{ xs: '32px 16px', md: '36px' }}
        >
            <Stack
                direction="row"
                alignItems="center"
                width="100%"
                gap="16px"
                css={{
                    textDecoration: 'none',
                    color: palette.common.black,
                }}
            >
                <Box>
                    <SvgIcon>
                        <IconHousekeeping css={{ fill: palette.primary.main }} />
                    </SvgIcon>
                </Box>

                <Typography variant="h3" flex={1} textTransform="uppercase">
                    {t('housekeeping')}
                </Typography>
            </Stack>
            <Box pt="32px">
                <Typography variant="h3" css={{ textTransform: 'uppercase' }}>
                    {t('housekeeping_no_upcoming_title')}
                </Typography>
                <Typography variant="body1" css={{ textTransform: 'uppercase' }}>
                    {t('housekeeping_no_upcoming_subtitle')}
                </Typography>
            </Box>
        </Stack>
    );
};
